var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-box"},[_c('div',{staticClass:"notification"},[_c('div',{staticClass:"inner"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-cancel")]),_vm._v(" To view the data, please select a venue")],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }